<app-customer-account-dialog>
    <div id="content">

        <div class="overlay view-participants">
            <div class="overlay-header">
                <h5>View Participants</h5>
                <div class="close-btn">
                    <button mat-icon-button mat-dialog-close (click)="closeViewParticipantModal()">
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                    </button>
                </div>
            </div>
            <div class="section-divider"></div>
            <section class="error-wrapper" *ngIf="batchAlertService.viewParticipantErrMsg">
                <f-alert variant="error">
                    <p>
                        There was problem loading the data. <a href="javascript:void('0')" (click)="loadData()"
                            class="btn-alert">Try again.</a>
                    </p>
                </f-alert>
            </section>


            <div class="overlay-body">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 left-panel">
                            <div class="row row-bottom-space">
                                <div class="col-md-12">
                                    <div class="data-label">Title</div>
                                    <div class="data-value">{{ selectedRow?.title}}</div>
                                </div>
                            </div>
                            <div class="row row-bottom-space">
                                <div class="col-md-6 ">
                                    <div class="data-label">Start</div>
                                    <div class="data-value">{{ selectedRow?.startDate}}</div>
                                </div>
                                <div class="col-md-6">
                                    <div class="data-label">End</div>
                                    <div class="data-value">{{ selectedRow?.endDate}}</div>
                                </div>
                            </div>
                            <div class="row row-bottom-space">
                                <div class="col-md-6">
                                    <div class="data-label">Created</div>
                                    <div class="data-value">{{ selectedRow?.created}}</div>
                                </div>
                                <div class="col-md-6">
                                    <div class="data-label">Created By</div>
                                    <div class="data-value">{{ selectedRow?.createdBy}}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="data-label">Details</div>
                                    <div class="data-value">{{ selectedRow?.description}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 right-panel">

                            <div class="participants-data">
                                <table mat-table [dataSource]="dataSource" class="mat-table"
                                aria-label="View Participants" *ngIf="!batchAlertService.viewParticipantErrMsg">

                                    <ng-container matColumnDef="globalUDPId">
                                        <th mat-header-cell *matHeaderCellDef> Global UDP ID </th>
                                        <td mat-cell *matCellDef="let element"> {{element.globalUDPId}} </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>

                            </div>
                        </div>

                        <div class="footer-controls" *ngIf="!batchAlertService.viewParticipantErrMsg">

                            <div class="footer-controls-left">
                                <div class="admin-table-count">
                                    <p class="display-result">
                                        <ng-container *ngIf="totalRecords >= 10">
                                            Displaying
                                            <strong>{{start + 1}}-{{end}} of {{totalRecords}}</strong> records
                                        </ng-container>
                                        <ng-container *ngIf="totalRecords < 10">
                                            Displaying
                                            <strong>{{start + 1}}-{{totalRecords}} of {{totalRecords}}</strong> records
                                        </ng-container>

                                    </p>

                                </div>
                            </div>
                            <div class="footer-controls-right">
                                <div class="custom-pagination hide1">
                                    <button class="arrow-btn" mat-stroked-button title="Start Page"
                                        [disabled]="isPreviousDisabled" (click)="goToFirstPage()">
                                        <f-icon icon-config='{"iconName": "chevrons-left", "iconType": "light", "iconSize": "s"}'></f-icon>
                                    </button>

                                    <button class="arrow-btn" mat-stroked-button title="Previous"
                                        [disabled]="isPreviousDisabled" (click)="goToPreviousPage()">
                                        <f-icon icon-config='{"iconName": "chevron-left", "iconType": "light", "iconSize": "s"}'></f-icon>
                                    </button>

                                    <span *ngFor="let num of visiblePageNumbers">
                                        <button class="number" title="{{num}}"
                                            [ngClass]="pageIndex + 1 === num ? 'selected' : ''"
                                            (click)="goToPageChange(num)" mat-stroked-button>
                                            {{num}}
                                        </button>
                                    </span>
                                    <button class="arrow-btn" mat-stroked-button title="Next"
                                        [disabled]="isNextDisabled" (click)="goToNextPage()">
                                        <f-icon icon-config='{"iconName": "chevron-right", "iconType": "light", "iconSize": "s"}'></f-icon>
                                    </button>

                                    <button class="arrow-btn" mat-stroked-button title="Last Page"
                                        [disabled]="isNextDisabled" (click)="goToLastPage()">
                                        <f-icon icon-config='{"iconName": "chevrons-right", "iconType": "light", "iconSize": "s"}'></f-icon>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</app-customer-account-dialog>